import { Notifications } from '@qred/components-library';
import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { CountryCode } from '~/enums';
import ErrorFallback from './components/shared/ErrorFallback/ErrorFallback';
import GlobalErrorPopup from './components/shared/GlobalErrorPopup/GlobalErrorPopup';
import HelpPopup from './components/shared/HelpPopup/HelpPopup';
import HubspotChat from './components/shared/HubspotChat/HubspotChat';
import ScrollToTop from './components/shared/ScrolToTop/ScrolToTop';
import { logToSentry } from './helpers/loggers.helper';
import { useAppInitEffects } from './hooks/useAppInitEffects';
import Routes from './routes';
import { RootState } from './store';
import { updateMatchedMedia } from './store/slices/matchedMedia.slice';
import GlobalStyle from './styles/index.css';

const Main: React.FC<RouteComponentProps<any>> = () => {
  const { market } = useSelector((state: RootState) => state.intl);
  const dispatch = useDispatch();
  useAppInitEffects();

  const onError = (error: Error) => {
    logToSentry(error, 'Uncaught error in Main.tsx');
  };

  useEffect(() => {
    if (market === CountryCode.NL) {
      document.title = 'Qeld | My Qeld';
    }

    return () => {
      document.title = 'Qred | My Qred';
    };
  }, [market]);

  const handleResize = () => {
    dispatch(updateMatchedMedia());
    document.documentElement.style.setProperty(
      '--client-height',
      `${window.innerHeight}px`
    );
  };

  useEffect(() => {
    dispatch(updateMatchedMedia());
    window.addEventListener('resize', handleResize);
    document.documentElement.style.setProperty(
      '--client-height',
      `${window.innerHeight}px`
    );
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <React.StrictMode>
      <ErrorBoundary onError={onError} fallback={<ErrorFallback />}>
        <Notifications />
        <GlobalStyle />
        <ScrollToTop />
        <GlobalErrorPopup />
        <HelpPopup />
        <HubspotChat />
        <Routes />
      </ErrorBoundary>
    </React.StrictMode>
  );
};

export default withRouter(Main);
